export const Constants = {
	GOOGLE: 1,
	REGISTERED_FROM: {
		APP: 1,
		WEB: 2,
	},
	LEVELS: {
		ADMIN: 1,
		OWNER: 2,
		BENEFICIARY: 3,
	},
	GENDER: {
		MALE: 1,
		FEMALE: 2,
	},
	ORDER: {
		STATUS: {
			PENDING: 0,
			APPROVED: 1,
			REJECTED: 2,
		},
	},
	ORDER_DOC: {
		FILENAME: {
			ORDER: 1,
			MEDICAL_REPORT: 2,
			DNI: 3,
			PRESCRIPTION: 4,
		},
	},
	PURCHASE: {
		STATUS: {
			PENDING: 0,
			APPROVED: 1,
			REJECTED: 2,
			CANCELLED: 3,
			ANALIZE: 4,
			NULLED: 5,
			APPROVED_ANALYSIS: 6,
		},
		TO_ANALIZE: {
			YES: 1,
			NO: 0,
		},
	},
	PAYMENT: {
		METHOD: {
			ADDRESS: 1,
			TRANSFER: 2,
			MOBILE: 3,
			CASH_USD: 4,
			ZELLE: 5,
			TRANSFER_MANUAL: 6,
			TRANSFER_BNC: 7,
		},
		PERIOD: {
			ANNUAL: 1,
			MONTHLY: 2,
			BIWEEKLY: 3,
			WEEKLY: 4,
		},
		TYPE: {
			PURCHASE: 1,	// Cuando realiza una compra (carrito)
			FEE: 2,				// Cuando paga una cuota
		},
		STATUS: {
			PENDING: 0,
			APPROVED: 1,
			REJECTED: 2,
		},
	},
	CURRENCY: {
		VED: 1,
		USD: 2,
	},
	TAXES: {
		IVA: 16,
		IGTF: 3,
	},
	BRAVEALO: {
		CATEGORY: {
			MOTO: 'Moto particular',
			AUTO: 'Automovil particular',
			CAMIONETA: 'Camioneta particular',
			CAMIONETA_CARGA: 'Camioneta Carga',
			CAMION_CARGA: 'Camion Carga',
			RUSTICO: 'Rustico particular'
		}
	},
};
